(function () {
  function parseVariantsJSON(root) {
    // Your theme prints: <script type="application/json">{{ product.variants | json }}</script>
    // There may be more than one JSON script on the page; we want the one inside the variant-radios block.
    const jsonScript = root.querySelector('script[type="application/json"]');
    if (!jsonScript) return null;

    try {
      const data = JSON.parse(jsonScript.textContent);
      return Array.isArray(data) ? data : null;
    } catch (e) {
      console.error('[variant-availability] Could not parse variants JSON:', e);
      return null;
    }
  }

  function getSelectedOptions(root) {
    // Reads currently checked radios per option name
    const selected = {};
    const checked = root.querySelectorAll('input[type="radio"]:checked');

    checked.forEach((input) => {
      selected[input.name] = input.value;
    });

    return selected;
  }

  function variantMatchesSelection(variant, selection, overrideName, overrideValue) {
    // Shopify variant JSON includes:
    // option1, option2, option3 (strings) and available (boolean)
    // We need to test whether this variant matches all selected options,
    // except for one option we are "testing" (overrideName -> overrideValue).

    // Build a map from option name order by reading fieldsets
    // We’ll do this differently: we will compare by optionN positions inferred from fieldsets.
    // For simplicity, we’ll compare by values only across names using DOM option positions.

    // This function is used with "selectionByPosition" instead, see below.
    return false;
  }

  function getOptionPositionMap(root) {
    // Returns an array of option meta in DOM order:
    // [{ name: 'Size', position: 1 }, { name: 'Color', position: 2 }, ...]
    const fieldsets = Array.from(root.querySelectorAll('fieldset.product-form__input[data-option-position]'));
    return fieldsets
      .map((fs) => ({
        name: fs.getAttribute('data-option-name') || '',
        position: parseInt(fs.getAttribute('data-option-position') || '0', 10),
      }))
      .filter((x) => x.name && x.position);
  }

  function selectionToByPosition(selectionByName, optionMeta) {
    // Convert { Size: 'M', Color: 'Indigo' } into {1:'M', 2:'Indigo'} using optionMeta
    const byPos = {};
    optionMeta.forEach((opt) => {
      if (selectionByName[opt.name] != null) {
        byPos[opt.position] = selectionByName[opt.name];
      }
    });
    return byPos;
  }

  function variantMatchesByPosition(variant, selectionByPos, overridePos, overrideValue) {
    // variant has option1/2/3
    // selectionByPos uses numeric positions (1,2,3)
    // overridePos means "assume this option position is overrideValue for matching"
    for (const posStr in selectionByPos) {
      const pos = parseInt(posStr, 10);
      const desired = (pos === overridePos) ? overrideValue : selectionByPos[pos];

      const vVal =
        pos === 1 ? variant.option1 :
        pos === 2 ? variant.option2 :
        pos === 3 ? variant.option3 :
        null;

      if (desired == null) continue;
      if (vVal !== desired) return false;
    }

    // Also ensure override itself matches (in case overridePos wasn't in selectionByPos yet)
    if (overridePos && overrideValue != null) {
      const vOverride =
        overridePos === 1 ? variant.option1 :
        overridePos === 2 ? variant.option2 :
        overridePos === 3 ? variant.option3 :
        null;

      if (vOverride !== overrideValue) return false;
    }

    return true;
  }

  function updateAvailability(root, variants) {
    const optionMeta = getOptionPositionMap(root);
    if (!optionMeta.length) return;

    const selectionByName = getSelectedOptions(root);
    const selectionByPos = selectionToByPosition(selectionByName, optionMeta);

    // For each option group (fieldset), check each value
    optionMeta.forEach((opt) => {
      const fieldset = root.querySelector(`fieldset.product-form__input[data-option-position="${opt.position}"]`);
      if (!fieldset) return;

      const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      radios.forEach((radio) => {
        const testValue = radio.value;

        // Determine if there exists an AVAILABLE variant matching:
        // all currently selected options, but with this option position set to testValue
        const existsAvailable = variants.some((v) => {
          if (!v.available) return false;
          return variantMatchesByPosition(v, selectionByPos, opt.position, testValue);
        });

        const label = fieldset.querySelector(`label[for="${CSS.escape(radio.id)}"]`);

        if (!existsAvailable) {
          radio.disabled = true;
          if (label) label.classList.add('is-soldout');
        } else {
          radio.disabled = false;
          if (label) label.classList.remove('is-soldout');
        }
      });

      // If currently checked radio became disabled (can happen when changing other option),
      // choose the first enabled radio in that fieldset.
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked && checked.disabled) {
        const firstEnabled = fieldset.querySelector('input[type="radio"]:not([disabled])');
        if (firstEnabled) {
          firstEnabled.checked = true;
          firstEnabled.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  function initVariantRadios(root) {
    const variants = parseVariantsJSON(root);
    if (!variants) return;

    // Initial paint
    updateAvailability(root, variants);

    // Update on any radio change
    root.addEventListener('change', (evt) => {
      const target = evt.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.type !== 'radio') return;

      updateAvailability(root, variants);
    });
  }

  function boot() {
    // There can be multiple variant-radios on a page (e.g. quick add),
    // but here we target your product page.
    const roots = document.querySelectorAll('variant-radios.no-js-hidden');
    roots.forEach((root) => initVariantRadios(root));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
